import React, { useEffect } from "react";
import "./Preview.scss";
import { Segmented, Avatar, Card, Rate } from "antd";
import {
  BellOutlined,
  ShoppingCartOutlined,
  EnvironmentFilled,
} from "@ant-design/icons";
import Helpers from "@utils/Helpers";
import { useUser } from "contexts/UserContext";
import { useUnit } from "contexts/UnitContext";
import distance from "@assets/icons/location-marker.svg";
import weight from "@assets/icons/weight.svg";
import contactIcon from "@assets/icons/contact.svg";
import filter from "@assets/img/product_filter.png";
import dayjs from "dayjs";

interface StepProps {
  adData: any;
  allProducts: any;
  selectedProduct: any;
}

const Preview: React.FC<StepProps> = ({
  adData,
  allProducts,
  selectedProduct,
}) => {
  const { userProfile } = useUser();
  const { units, convertCurrency } = useUnit();
  const [dateLeft, setDateLeft] = React.useState({
    days: "",
    hours: "",
    minutes: "",
  });

  const previewDiscountedPrice = (): number => {
    let finalDiscountedPrice = 0;
    if (adData.discounted_unit == "tons") {
      console.log(adData.discounted_price);

      finalDiscountedPrice = adData.discounted_price / 1000;
    } else {
      finalDiscountedPrice = convertCurrency(
        adData.discounted_price / selectedProduct.bale_weight,
        units.currency,
        "USD"
      );
    }
    return finalDiscountedPrice;
  };

  useEffect(() => {
    const end = new Date(
      dayjs(adData?.start_time)
        .add(adData?.duration, "weeks")
        .format("YYYY-MM-DD HH:mm:ss")
    );
    const currentDate = new Date();
    const timeDiff = end.getTime() - currentDate.getTime();
    const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));

    const hoursLeft = Math.ceil(
      (timeDiff % (1000 * 3600 * 24)) / (1000 * 3600)
    );
    const minutesLeft = Math.ceil((timeDiff % (1000 * 3600)) / (1000 * 60));
    setDateLeft({
      days: daysLeft < 10 ? `0${daysLeft}` : daysLeft.toString(),
      hours: hoursLeft < 10 ? `0${hoursLeft}` : hoursLeft.toString(),
      minutes: minutesLeft < 10 ? `0${minutesLeft}` : minutesLeft.toString(),
    });
  }, []);

  return (
    <div className="Preview">
      <div className="item-title">
        <b>Preview & Publish</b>
      </div>

      <Segmented
        className="view-mode"
        size="middle"
        options={[
          {
            label: "Desktop",
            value: "desktop",
          },
          {
            label: "Mobile",
            value: "mobile",
          },
        ]}
      ></Segmented>

      <div className="preview">
        <div className="preview-header">
          <b className="preview-header-title">Preview mode</b>
        </div>
        <div className="preview-content">
          <div className="header">
            <div className="navbar-brand">
              <img
                src={Helpers.getImageFrontPage("logo")}
                height="50px"
                alt=""
              />
            </div>
            <div className="menu-group">
              <span className="nav-item">Products</span>
              <span className="nav-item">Producers</span>
              <span className="nav-item">Transactions</span>

              <div className="personal-group">
                <div className="personal-item">
                  <div className="unit-item distance">
                    <img
                      src={distance}
                      alt="distance"
                      width={16}
                      className="icon"
                    />{" "}
                    {units.distance}
                  </div>
                  |
                  <div className="unit-item">
                    <img
                      src={weight}
                      alt="weight"
                      width={16}
                      className="icon"
                    />{" "}
                    {units.weight}
                  </div>
                </div>

                <div className="personal-item">
                  <img
                    src={contactIcon}
                    alt="contact"
                    width={20}
                    className="icon"
                  />
                </div>

                <div className="personal-item">
                  <BellOutlined className="icon" />
                </div>
                <div className="personal-item">
                  <ShoppingCartOutlined className="icon" />
                </div>

                {userProfile?.avatar ? (
                  <img
                    className="user-avatar"
                    width={32}
                    height={32}
                    src={userProfile?.avatar!}
                    alt="avatar"
                  />
                ) : (
                  <Avatar size={32} className="user-avatar default">
                    {userProfile?.first_name[0].toUpperCase()}
                  </Avatar>
                )}
              </div>
            </div>
          </div>
          <img src={filter} alt="filter" className="filter" />
          <div className="section">
            <b className="section-title">Promoted Products ⚡</b>
            <div className="product-list">
              <Card
                className="product-item blink"
                cover={
                  <img
                    src={selectedProduct.images[0]}
                    className="product-image"
                    alt="product"
                  />
                }
              >
                <div className="product-type ">
                  - {adData.discounted_percent}%
                </div>
                <div className="product-info">
                  <div className="product-name">{selectedProduct.hay_type}</div>
                  <div className="product-rating">
                    <Rate disabled defaultValue={selectedProduct.rate} />
                    <span className="reviews">0 reviews</span>
                  </div>
                  <div className="product-price">
                    <div className="price">
                      ${Helpers.formatNumber(previewDiscountedPrice(), 2)} /{" "}
                      {units.weight}
                    </div>

                    <div className="origin-price">
                      $
                      {Helpers.formatNumber(
                        convertCurrency(
                          selectedProduct.price_per_tons,
                          "USD",
                          units.currency
                        ),
                        2
                      )}{" "}
                      / {units.weight}
                    </div>

                    <div className="quantity">
                      Quantity: {adData.discounted_quantity} bales
                    </div>
                  </div>

                  <div className="ad-duration">
                    <div className="ad-time-group">
                      <div className="time-item">
                        <div className="value">{dateLeft.days}</div>
                        <div className="unit">days</div>
                      </div>
                      <div className="time-item">
                        <div className="value">{dateLeft.hours}</div>
                        <div className="unit">hrs</div>
                      </div>
                      <div className="time-item">
                        <div className="value">{dateLeft.minutes}</div>
                        <div className="unit">mins</div>
                      </div>
                    </div>
                  </div>

                  <div className="product-action">
                    <div className="location">
                      <EnvironmentFilled />{" "}
                      {selectedProduct.farm_details.farm_city
                        ? selectedProduct.farm_details.farm_city + ","
                        : ""}{" "}
                      {selectedProduct.farm_details.farm_province}
                    </div>
                  </div>
                </div>
              </Card>
              {allProducts
                .filter((product: any) => product.ad)
                .slice(0, 3)
                .map((item: any) => {
                  const convertPrice = item.price_per_tons;
                  const discounted_price = item.ad.discounted_price;
                  return (
                    <Card
                      key={item.product_id}
                      className="product-item"
                      cover={
                        <img
                          src={item.images[0]}
                          className="product-image"
                          alt="product"
                        />
                      }
                    >
                      <div className="product-type ">
                        - {item.ad.discounted_percent}%
                      </div>
                      <div className="product-info">
                        <div className="product-name">{item.hay_type}</div>
                        <div className="product-rating">
                          <Rate disabled defaultValue={item.rate} />
                          <span className="ms-1">0 reviews</span>
                        </div>
                        <div className="product-price">
                          <div className="price">
                            $
                            {Helpers.formatNumber(
                              convertCurrency(
                                discounted_price,
                                "USD",
                                units.currency
                              ),
                              2
                            )}{" "}
                            / {units.weight}
                          </div>

                          <div className="origin-price">
                            $
                            {Helpers.formatNumber(
                              convertCurrency(
                                (convertPrice * 120) / 100,
                                "USD",
                                units.currency
                              ),
                              2
                            )}{" "}
                            / {units.weight}
                          </div>

                          <div className="quantity">
                            Quantity: {item.ad.discounted_quantity} bales
                          </div>
                        </div>

                        <div className="ad-duration">
                          <div className="ad-time-group">
                            <div className="time-item">
                              <div className="value">0</div>
                            </div>
                            <div className="time-item">
                              <div className="value">0</div>
                            </div>
                            <div className="time-item">
                              <div className="value">0</div>
                            </div>
                          </div>
                        </div>

                        <div className="product-action">
                          <div className="location">
                            <EnvironmentFilled />{" "}
                            {item.farm_details.farm_city
                              ? item.farm_details.farm_city + ","
                              : ""}{" "}
                            {item.farm_details.farm_province}
                          </div>
                        </div>
                      </div>
                    </Card>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="preview-footer"></div>
      </div>
    </div>
  );
};

export default Preview;
